import React from "react";
import Banner from "../components/utilities/Banner";
import Timeline from "../components/Portfolio/Timeline/Timeline";
import Bio from "../components/Portfolio/Bio";
function Portfolio() {
  return (
    <div className="container">
      <Banner />
      <Timeline />
    </div>
  );
}

export default Portfolio;
